import {
  SiElasticsearch,
  SiPostgresql,
  SiMysql,
  SiAmazonaws,
} from 'react-icons/si'
// @ts-ignore
import React from 'react'

interface SkillsType {
  name: string
  icon: any
  link: string
}

export const DatabaseSkillsData: SkillsType[] = [
  {
    name: 'Elastic Search',
    icon: <SiElasticsearch color="#ffffffdc" />,
    link: 'https://www.javascript.com/',
  },
  {
    name: 'PostgreSQL',
    icon: <SiPostgresql color="#ffffffdc" />,
    link: 'https://www.typescriptlang.org/',
  },
  {
    name: 'MySQL',
    icon: <SiMysql color="#ffffffdc" />,
    link: 'https://reactjs.org/',
  },
  {
    name: 'AWS S3',
    icon: <SiAmazonaws color="#ffffffdc" />,
    link: 'https://nextjs.org/',
  },
]
